"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserManagementRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const user_1 = require("../../../../service-lib/src/lib/entities/user");
const employee_entity_1 = require("../../../../service-lib/src/lib/entities/employee.entity");
const user_role_entity_1 = require("../../../../service-lib/src/lib/entities/user-role.entity");
const constants_1 = require("../../../../service-lib/src/lib/constants");
let UserManagementRepository = class UserManagementRepository {
    constructor(userRepo, empRepo, userRoleRepo) {
        this.userRepo = userRepo;
        this.empRepo = empRepo;
        this.userRoleRepo = userRoleRepo;
    }
    async createUser(data) {
        const user = this.userRepo.create(data);
        const saved = await this.userRepo.save(user);
        return saved;
    }
    async updateUser(id, data) {
        await this.userRepo.update({ userId: id }, data);
        return this.userRepo.findOne({ where: { userId: id } });
    }
    async softDeleteUser(id) {
        await this.userRepo.update({ userId: id }, { deletedAt: new Date() });
    }
    async getUsers(skip = 0, take = 10, userType) {
        const where = userType ? { userTypeKey: userType } : {};
        return this.userRepo.find({ where, skip, take });
    }
    async syncEmployee(user) {
        if (user.userTypeKey === constants_1.USER_TYPE_IIRM_EMPLOYEE) {
            const emp = this.empRepo.create({
                userId: user.userId,
                firstName: user.firstName,
                lastName: user.lastName,
                emailId: user.emailId,
                mobile: user.mobile,
                branchId: user.branchId,
                departmentId: user.departmentId,
                designationId: user.designationId,
                verticalId: user.verticalId,
                reportingUserId: user.reportingUserId,
                organisationId: 0,
                statusLid: 0,
                iirmEmpId: '',
                reportingManagerEmployeeId: 0,
                createdBy: user.createdBy,
                updatedBy: user.updatedBy,
            });
            await this.empRepo.save(emp);
        }
    }
};
exports.UserManagementRepository = UserManagementRepository;
exports.UserManagementRepository = UserManagementRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(user_1.User)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(employee_entity_1.Employee)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(user_role_entity_1.UserRole)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object])
], UserManagementRepository);
